import { render, staticRenderFns } from "./SharesUpdate.vue?vue&type=template&id=1c073a18&"
import script from "./SharesUpdate.vue?vue&type=script&lang=js&"
export * from "./SharesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports